export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-canva@2x.4c2d6eaa9b716e2a2ad9d2ab152000db.png";